import { TextField } from '@src/shared/ui/fields';
import { useTranslation } from 'react-i18next';

type NotesFieldProps = {
  disabled?: boolean;
};

export default function NotesField({ disabled = false }: NotesFieldProps) {
  const { t } = useTranslation();

  return (
    <TextField
      disabled={disabled}
      multiline
      fullWidth
      label={t('absence.schedule.field_notes', 'Notes')}
      name="notes"
      rows={5}
    />
  );
}
